import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TweenLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";

export class WinterHoardBetlineNumber extends PIXI.Container {

    private readonly _map: number[] = [
        12,1,20,7,24,15,11,2,13,8,10,3,14,6,16,21,9,4,17,5,
        31,25,37,29,32,19,36,26,38,30,33,18,35,23,39,28,34,22,40,27
    ];
    private readonly _numberPosY:number[] = [
        42.5,65,102.5,126.5,166,187.5,229,252.5,294,317,349.5,372.5,412.5,435.5,469.5,493.5,533.5,556,597.5,621.5,
        42.5,66,102.5,126,164.5,187.5,228,251.5,294,317,350,371.5,413.5,437,470.5,493,532,555,597,621
    ];
    private readonly _numberPosX:number[] = [
       25,38,23,39,24,38,24,38,25,38,23.5,36,24.5,37.5,25,37.5,24,37,24.5,36,
        805,790.5,805,791.5,804.5,790.5,804.5,791.5,805.5,790.5,805.5,791.5,805,791.5,804.5,791.5,804.5,792.5,804.5,792.5
    ];

    private _index: number;
    private _isPlayingWin: boolean;
    private _normal: PIXI.Sprite;
    private _normalAlphaTween: TweenLite;
    private _normalScaleTween: TweenLite;

    private _win: PIXI.Sprite;
    private _winAlphaTween: TweenLite;
    private _winScaleTween: TweenLite;
    public _layer:PIXI.Container;

    private _winValueHolder: PIXI.Text;
    private left: boolean = true;
    private origX: number = 0;


    public get index(): number {
        return this._index;
    }

    constructor(index: number, layer:PIXI.Container) {
        super();
        this._layer = layer;
        this._index = index;
        this.draw();
        this.initButtonMode();
        this.addEventListeners();
    }

    private addEventListeners(): void {
        EventHandler.addEventListener(this, BetLineEvent.SET_ENABLED, (event: GameEvent) => this.setEnabled(event.params[0]));
        EventHandler.addEventListener(this, BetLineEvent.HIDE_ALL_BET_LINES, (event: GameEvent) => this.onHideAllBetLines());
    }

    private initButtonMode(): void {
        //this.setEnabled(true);
        //this.on('mouseover', this.onMouseOver);
        //this.on('mouseout', this.onMouseOut);
    }

    public setPosition(betLinesNum: number): number[] {
        const mapIndex = this._map.indexOf(this.index),
            side: number = mapIndex > 19 ? 1 : 0;

        this.x = this._numberPosX[mapIndex]-40;
        this.y = this._numberPosY[mapIndex]+50;
        return [this.x, this.y, side];
    }

    private createAllWinLineValueHolders(): void {
        //for (let x = 0; x < 19; x++) {
            this.createWinValueHolder();
        //}
    }

    private createWinValueHolder():void {
        const mapIndex = this._map.indexOf(this.index),
            side: number = mapIndex > 19 ? 1 : 0;

        const x:number = (side === 1)? this._numberPosX[mapIndex] - 120 : this._numberPosX[mapIndex] - 5;
        const y:number = this._numberPosY[mapIndex] + 35;

        const valHolder:PIXI.Text = new PIXI.Text("0.00", {
            fontFamily : "Open Sans",
            fontSize : 24,
            fontWeight : FontWeight.BOLD,
            //align : "center",
            alpha: 0.6,
            dropShadow : true,
            dropShadowAlpha : 0.6,
            dropShadowAngle : 89.5,
            dropShadowBlur : 6,
            dropShadowColor : "#1a1740",
            dropShadowDistance : 3,
            fill : [
                "#fff7e8",
                "#fffdec",
                "#fff0aa",
                "#ffc733"
            ],
            miterLimit : 7,
            stroke : "#bd1e96",
            strokeThickness : 1
        });
        valHolder.x = x;
        valHolder.y = y;
        valHolder.alpha = 0;
        valHolder.visible = false;
        this.origX = x;

        this.left = (side === 0);

        this._winValueHolder = valHolder;
        this._layer.addChild(valHolder);
    }

    private onMouseOver(): void {
        if (this._isPlayingWin) {
            return;
        }

        if (UserAgent.isMobile) {
            return;
        }
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SHOW_STATIC_BET_LINE, this.index));
        this.showMouseOver();
    }

    private onMouseOut(): void {
        if (this._isPlayingWin) {
            return;
        }
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_STATIC_BET_LINE, this.index));
        this.showMouseOut();
    }

    private onShowWinBetLine(index: number): void {
        if (index !== this._index) {
            return;
        }

        this._isPlayingWin = true;
        this.showWin("");
    }

    private onHideWinBetLine(index: number): void {
        if (index !== this._index) {
            return;
        }

        this.onHideAllBetLines();
    }

    private onHideAllBetLines(): void {
        this._isPlayingWin = false;
        this.showNormal();
    }

    private setEnabled(value: boolean): void {
        this.interactive = false;
        this.onHideAllBetLines();
    }

    public disable():void {
        this.interactive = false;
        //this.onHideAllBetLines();
        //WinterHoardGameModuleConfig.animatedWinLines.cleanUpAnimatedWinlines();
    }


    /**
     * @description This is overridden to apply background image to betline numbers.
     *
     * @param config
     */
    protected draw(): void {
        this.addChild(this.addGlow());
        this.addChild(this.addNumber());
        this._layer.addChild(this);

        //if(this._winValueHolders.length === 0)
        // TODO: FLAG
        this.createWinValueHolder();

        //console.log(this._winValueHolders);

        //if(this.index === 1) {
           /*new TimelineMax({repeat: -1}).add([
                TweenLite.fromTo(this._winValueHolder, 0.4, {x: this.origX}, {x: (this.left)? this.origX + 80 : this.origX - 80}),
                TweenLite.fromTo(this._winValueHolder, 0.2, {alpha: 0}, {alpha: 1})
            ]).add(TweenLite.fromTo(this._winValueHolder, 0.2, {alpha: 1}, {alpha: 0}));*/
        //}
    }

    protected showMouseOver(): void {

        this.killAll();

        this._normalAlphaTween = TweenLite.to(this._normal, 0.1, {alpha: 0});
        this._winAlphaTween = TweenLite.to(this._win, 0.1, {alpha: 1});
    }

    protected showMouseOut(): void {

        this.killAll();

        this._normalAlphaTween = TweenLite.to(this._normal, 0.1, {alpha: 11});
        this._winAlphaTween = TweenLite.to(this._win, 0.1, {alpha: 0});
    }

    protected showWin(winVal:string): void {

        this.killAll();

        this._normalAlphaTween = TweenLite.to(this._normal, 0.1, {alpha: 0});
        this._winAlphaTween = TweenLite.to(this._win, 0.1, {alpha: 1});
        this._normalScaleTween = TweenLite.to(this._normal.scale, 0.17, {
            x: 1,
            y: 1
        });
        this._winScaleTween = TweenLite.to(this._win.scale, 0.17, {
            x: 1,
            y: 1
        });
        // TODO: FLAG
        new TimelineLite().add([
            () => {
                this._winValueHolder.text = Currency.formatValue(Number(winVal)).toString();
                this._winValueHolder.visible = true;
            },
            TweenLite.fromTo(this._winValueHolder, 0.4, {x: this.origX}, {x: (this.left)? this.origX + 20 : this.origX - 20}),
            TweenLite.fromTo(this._winValueHolder, 0.2, {alpha: 0}, {alpha: 1})
        ]).add(TweenLite.fromTo(this._winValueHolder, 0.2, {alpha: 1}, {alpha: 0}), "+=0.3")
            .add(() => {
                this._winValueHolder.visible = false;
            });
    }

    public showNormal(): void {

        this.killAll();

        this._normalAlphaTween = TweenLite.to(this._normal, 0.33, {alpha: 1});
        this._winAlphaTween = TweenLite.to(this._win, 0.33, {alpha: 0});
        this._normalScaleTween = TweenLite.to(this._normal.scale, 0.33, {x: 1, y: 1});
        this._winScaleTween = TweenLite.to(this._win.scale, 0.33, {x: 1, y: 1});
    }

    private addGlow(): PIXI.DisplayObject {
        const name: string = "betlineNumberGlow";

        this._win = this.createImageItem(name);

        return this._win;
    }

    private addNumber(): PIXI.DisplayObject {
        const name: string = "betlineNumber";

        this._normal = this.createImageItem(name);
        this._normal.alpha = 1;
        return this._normal;
    }

    private createImageItem(name: string): PIXI.Sprite {
        const offset: number = 2.5;
        let item: PIXI.Sprite;

        item = new PIXI.Sprite(GameResources.getTextures(name + this.index)[0]);
        item.anchor.set(0.5);
        item.x -= offset;
        item.y -= offset;

        return item;
    }

    private killAll(): void {
        if (this._normalAlphaTween && this._normalAlphaTween.isActive()) {
            this._normalAlphaTween.pause();
            this._normalAlphaTween.kill();
        }

        if (this._normalScaleTween && this._normalScaleTween.isActive()) {
            this._normalScaleTween.pause();
            this._normalScaleTween.kill();
        }

        if (this._winAlphaTween && this._winAlphaTween.isActive()) {
            this._winAlphaTween.pause();
            this._winAlphaTween.kill();
        }

        if (this._winScaleTween && this._winScaleTween.isActive()) {
            this._winScaleTween.pause();
            this._winScaleTween.kill();
        }
    }

    public showIndividualNumber(index: number, winVal:string): void {
        if (index + 1 !== this.index) {
            return;
        }

        this.showWin(winVal);
    }
}